import React, { FunctionComponent } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import Button from '../common/Button';
import { useCall } from '../../customer-call-sdk';

export interface AlertDialogBoxProps {
    isVideoMailAlertPopupVisible: boolean;
    handleClose?: () => void;
    handleConfirmClick?: () => void;
}

const BootstrapButton = styled(Button)({
    width: '80%',
    heigth: '200px',
    borderRadius: '50px',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#0063cc !important',
    borderColor: '#0063cc !important',
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        backgroundColor: '#0069d9',
        borderColor: '#0062cc',
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: '#0062cc',
        borderColor: '#005cbf',
    },
    '&:focus': {
        boxShadow: '0 0 0 0.1rem rgba(0,123,255,.5)',
    },
});

const AlertDialog: FunctionComponent<AlertDialogBoxProps> = ({
    isVideoMailAlertPopupVisible,
    handleClose,
    handleConfirmClick,
}) => {
    const call = useCall();
    return (
        <>
            <Dialog open={isVideoMailAlertPopupVisible} onClose={handleClose}>
                <DialogTitle />
                <DialogContent
                    style={{
                        minWidth: '70px',
                        maxWidth: '510px',
                        minHeight: '70px',
                        padding: '20px',
                    }}
                >
                    <DialogContentText style={{ color: '#000000', width: '100%' }}>
                        <div>
                            <b>{call.messageForVideoMail}</b>
                            <br />
                        </div>
                        <div>
                            <b>Do you want to send a videomail ?</b>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'space-between' }}>
                    <Button
                        onClick={handleClose}
                        style={{
                            outline: 'none',
                            borderRadius: '100px',
                            backgroundColor: '#4d4d4d',
                            outlineColor: '#4d4d4d',
                            borderColor: '#4d4d4d',
                            width: '225px',
                            marginLeft: '10px',
                        }}
                        aria-label="Cancel"
                    >
                        Cancel
                    </Button>
                    <BootstrapButton
                        variant="contained"
                        onClick={handleConfirmClick}
                        color="primary"
                        disableRipple
                        sx={{ margin: 1 }}
                        style={{
                            outline: 'none',
                            borderRadius: '100px',
                            width: '225px',
                            marginRight: '10px',
                        }}
                        aria-label=" Send Videomail"
                    >
                        SEND VIDEOMAIL
                    </BootstrapButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AlertDialog;
